import dividerPrimaryGradientUrl from "../../assets/img/border/divider-primary-gradient.svg"
import { PATHS } from "../../constants/paths"
import { socials } from "../../data/socials"

import {
  Box,
  Container,
  Divider,
  Grid,
  IconButton,
  Link,
  Stack,
  Typography,
} from "@mui/material"
import Button from "@mui/material/Button"
import useMediaQuery from "@mui/material/useMediaQuery"
import React from "react"
import { NavLink } from "react-router-dom"

export const Footer = () => {
  const isDownSm = useMediaQuery("(max-width: 600px)")

  return (
    <Box
      component={"footer"}
      py={2}
      sx={{
        borderTop: "1px solid transparent",
        borderImage: `url(${dividerPrimaryGradientUrl}) 1 stretch`,
      }}
    >
      <Container fixed>
        <Grid
          container
          // justifyContent={!isDownSm ? "space-between" : "center"}
          justifyContent={"space-between"}
          alignItems="center"
        >
          <Grid item>
            <Typography color="secondary">
              {new Date().getFullYear()} |{" "}
              <span style={{ fontSize: "1rem" }}>Ⓒ</span> Zombie TD
            </Typography>
          </Grid>
          <Grid item>
            <Stack
              direction="row"
              spacing={isDownSm ? 0.5 : 2}
              divider={
                isDownSm ? null : <Divider orientation="vertical" flexItem />
              }
            >
              {!isDownSm && (
                <>
                  <Button
                    component={NavLink}
                    to={PATHS.TERMS_OF_USE.PATH}
                    color="secondary"
                    className="nav-link"
                  >
                    {PATHS.TERMS_OF_USE.LABEL}
                  </Button>
                  <Button
                    component={NavLink}
                    to={PATHS.PRIVACY_POLICY.PATH}
                    color="secondary"
                    className="nav-link"
                  >
                    {PATHS.PRIVACY_POLICY.LABEL}
                  </Button>
                </>
              )}
              {socials.map((social) => (
                <IconButton component={Link} href={social.link} target="_blank">
                  {social.icon}
                </IconButton>
              ))}
            </Stack>
          </Grid>
        </Grid>
      </Container>
    </Box>
  )
}
